// extracted by mini-css-extract-plugin
export var root = "aKeV";
export var rootContent = "_0tfS";
export var rootDescription = "vQqc";
export var rootHeading = "_2vNL";
export var rootImage = "ghpJ";
export var rootPicture = "+-NO";
export var rootSmall = "Qzwt";